<template>
    <div class="tw-bg-primary-100 tw-py-2">
        <div class="tw-mx-auto tw-max-w-7xl tw-px-4 tw-py-16 md:tw-py-24">
    <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-12 tw-items-center">      
      <div class="tw-flex tw-flex-col tw-justify-center tw-pr-0 md:tw-pr-8">
        <div class="tw-flex tw-items-center tw-gap-4 tw-mb-6">
          <div class="tw-h-px tw-w-8 tw-bg-gray-400"></div>
          <span class="tw-text-xs tw-uppercase tw-tracking-widest tw-font-semibold tw-text-gray-600">
            Cake Design com Alma
          </span>
        </div>

        <h1 class="tw-font-serif tw-mb-6 tw-text-5xl md:tw-text-6xl tw-leading-tight tw-text-gray-900">
          A arte de fazer bolos,<br>
          <span class="tw-italic tw-text-secondary">no coração da serra.</span>
        </h1>

        <p class="tw-mb-10 tw-max-w-md tw-text-lg tw-font-light tw-text-gray-600">
          Sou a Marina e acredito que não há um bolo que não possa ser motivo de um sorriso. Partilho contigo um bocadinho dos meus trabalhos, feitos à mão com todo o carinho.
        </p>

        <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-6 tw-mb-12">
          <v-btn
            :to="{ name: 'About' }"
            size="x-large"
            class="tw-rounded-full tw-bg-secondary-400 tw-text-white tw-px-8 tw-normal-case tw-tracking-wide"
            elevation="0">
            Descobrir Mais
            <v-icon right class="tw-ml-2">mdi-arrow-top-right</v-icon>
          </v-btn>
          
          <a :to="{ name: 'Portfolio' }" class="tw-text-sm tw-font-medium tw-text-gray-800 hover:tw-text-secondary-400 tw-transition-colors">
            Ver galeria <v-icon size="small">mdi-arrow-right</v-icon>
          </a>
        </div>

        <div class="tw-flex tw-items-center tw-gap-4 tw-mt-auto">
          <div class="tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-full tw-border tw-border-gray-200">
            <v-icon color="#6E3C4B">mdi-hand-heart-outline</v-icon>
          </div>
          <div class="tw-text-sm tw-text-gray-600">
            <p class="tw-m-0">Tu trazes a ideia,</p>
            <p class="tw-m-0 tw-font-semibold">A Marina dá-lhe forma.</p>
          </div>
        </div>
      </div>

      <div class="tw-relative tw-flex tw-items-start tw-gap-6">
        
        <div class="tw-relative tw-w-2/3 tw-h-[500px] tw-overflow-hidden tw-rounded-tl-[80px] tw-rounded-br-[80px] tw-rounded-tr-2xl tw-rounded-bl-2xl tw-shadow-lg">
          <v-img
            src="@/assets/images/nePhotos/WhatsApp Image 2026-10-23 at 10.11.59 (Edited).jpeg"
            cover
            class="tw-h-full tw-w-full"
          />
          <div class="tw-absolute tw-bottom-6 tw-left-6 tw-bg-white/90 tw-backdrop-blur-sm tw-px-4 tw-py-2 tw-rounded-full tw-text-xs tw-font-medium tw-text-gray-800 tw-shadow-sm">
            <span class="tw-text-secondary-400 tw-mr-1">●</span> Uma criação do atelier
          </div>
        </div>

        <div class="tw-w-1/3 tw-flex tw-flex-col tw-gap-6 tw-pt-12">
          
          <div class="tw-flex tw-justify-center">
            <div class="tw-h-24 tw-w-24 tw-rounded-full tw-bg-secondary-400 tw-flex tw-items-center tw-justify-center tw-shadow-sm tw-p-4">
              <v-img
                src="@/assets/images/cake-logo-white.png"
                contain
                class="tw-h-full tw-w-full"
              />
            </div>
          </div>

          <!-- Imagem Secundária -->
          <div class="tw-h-[250px] tw-w-full tw-overflow-hidden tw-rounded-t-[100px] tw-rounded-b-2xl tw-shadow-md">
            <v-img
              src="@/assets/images/nePhotos/WhatsApp Image 2026-10-23 at 10.12.01.jpeg"
              cover
              class="tw-h-full tw-w-full"
            />
          </div>

          <div class="tw-px-2">
            <h3 class="tw-font-serif tw-text-2xl tw-text-gray-800 tw-leading-tight">
              Da serra,<br>
              <span class="tw-italic tw-text-secondary">com carinho.</span>
            </h3>
          </div>

        </div>
      </div>
      
    </div>
  </div>
    </div>

    <section class="tw-bg-primary-100 tw-py-10">
        <div class="tw-mx-auto tw-max-w-7xl tw-px-4">
            <div class="tw-mb-12 tw-text-center">
                <span class="tw-text-sm tw-font-medium tw-uppercase tw-tracking-widest tw-text-secondary">Os mais famosos</span>
                <div class="tw-mx-auto tw-mt-4 tw-h-1 tw-w-16 tw-bg-secondary"></div>
            </div>

            <div class="tw-grid tw-grid-cols-1 tw-gap-8 sm:tw-grid-cols-2 lg:tw-grid-cols-3">
                <div
                    v-for="product in bestSellers"
                    :key="product.id"
                    class="tw-group tw-overflow-hidden tw-bg-white tw-transition-all tw-duration-300 hover:tw-shadow-xl">
                    <div class="tw-relative tw-h-80 tw-overflow-hidden">
                        <v-img
                            :src="product.image"
                            cover
                            class="tw-h-full tw-w-full tw-transition-transform tw-duration-500 group-hover:tw-scale-110" />
                    </div>

                    <div class="tw-bg-primary tw-p-6 tw-text-center">
                        <h3 class="tw-font-serif tw-mb-2 tw-text-xl tw-text-secondary">{{ product.name }}</h3>
                        <p class="tw-mb-4 tw-line-clamp-2 tw-text-sm tw-text-gray-600">
                            {{ product.description }}
                        </p>

                        <button
                            type="button"
                            class="tw-rounded-full tw-bg-secondary tw-px-5 tw-py-2 tw-text-xs tw-font-semibold tw-text-[#FBF6E8] tw-transition-colors hover:tw-bg-secondary-400"
                            @click="orderThis(product)">
                            Encomendar este bolo
                        </button>
                    </div>
                </div>
            </div>

            <div class="tw-mt-12 tw-text-center">
                <router-link
                    :to="{ name: 'Portfolio' }"
                    class="tw-text-secondary tw-underline tw-underline-offset-4">
                    Ver toda a nossa montra
                </router-link>
            </div>
        </div>
    </section>

    <section class="tw-bg-primary tw-py-16">
        <div class="tw-mx-auto tw-max-w-6xl tw-px-4">
            <div class="tw-flex tw-flex-col tw-items-center tw-gap-16 md:tw-flex-row">
                <div class="tw-w-full md:tw-w-1/2">
                    <div class="tw-relative tw-mx-auto tw-w-full md:tw-w-1/2">
                        <div class="tw-absolute -tw-bottom-0 -tw-right-48 tw-z-0 tw-h-48 tw-w-48 tw-rounded-full tw-bg-secondary/15"></div>

                        <v-img
                            src="@/assets/images/marina4.jpg"
                            cover
                            width="800"
                            class="tw-relative tw-z-10 tw-rounded-lg tw-shadow-2xl md:tw-translate-x-20 md:-tw-translate-y-10" />
                    </div>
                </div>

                <div class="tw-w-full md:tw-w-1/2">
                    <div class="tw-mb-4 tw-flex tw-items-center tw-gap-4">
                        <div class="tw-h-[1px] tw-w-12 tw-bg-secondary"></div>
                        <span class="tw-text-sm tw-font-medium tw-uppercase tw-tracking-widest tw-text-secondary"> Qualidade & Afeto </span>
                    </div>

                    <h2 class="tw-font-serif tw-mb-6 tw-text-3xl tw-text-secondary md:tw-text-4xl">Bem vindos ao Atelier da Marina!</h2>

                    <div class="tw-relative">
                        <span class="tw-font-serif tw-absolute -tw-left-4 -tw-top-4 tw-select-none tw-text-6xl tw-italic tw-text-secondary tw-text-secondary/20"> “ </span>

                        <p class="tw-relative tw-z-10 tw-text-xl tw-font-light tw-italic tw-text-secondary tw-leading-relaxed tw-text-gray-700 md:tw-text-2xl">
                            A nossa cozinha tem a melhor vista do mundo: as montanhas de Pitões das Júnias. É aqui a mais de 1100 metros de altitude, rodeada pela tranquilidade e pela natureza, que a
                            magia acontece todos os dias...
                        </p>
                    </div>

                    <div class="tw-mt-8 tw-flex tw-items-center tw-gap-3">
                        <v-avatar size="40">
                            <v-img
                                src="@/assets/images/logo-marina.png"
                                alt="Marina" />
                        </v-avatar>
                        <div>
                            <p class="tw-font-serif tw-mb-0 tw-text-sm tw-text-secondary">Com carinho,</p>
                            <p class="tw-text-xs tw-uppercase tw-tracking-tighter tw-text-gray-600">Atelier da Marina</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="tw-bg-[#FBF6E8] tw-py-10 md:tw-py-18">
        <div class="tw-mx-auto tw-grid tw-max-w-6xl tw-grid-cols-1 tw-items-start tw-gap-12 tw-px-4 lg:tw-grid-cols-12 lg:tw-gap-16">
            <div class="lg:tw-col-span-4 lg:tw-pt-2">
                <p class="tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-[0.22em] tw-text-gray-500">Antes de começarmos</p>
                <h2 class="tw-font-serif tw-mt-5 tw-text-4xl tw-leading-[1.05] tw-text-[#3d2428] md:tw-text-5xl">
                    As tuas dúvidas,<br />
                    <span class="tw-italic tw-text-secondary tw-text-secondary-400">sem complicar.</span>
                </h2>
                <p class="tw-mt-6 tw-max-w-xs tw-text-sm tw-leading-relaxed tw-text-gray-600">Para chegares à conversa com uma ideia mais clara.</p>
                <router-link
                    :to="{ name: 'Order' }"
                    class="tw-mt-8 tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-font-medium tw-text-[#3d2428] hover:tw-text-secondary-400">
                    Preparar o meu pedido
                    <v-icon size="16">mdi-arrow-right</v-icon>
                </router-link>
            </div>

            <div class="lg:tw-col-span-8">
                <div
                    v-for="(item, index) in faqs"
                    :key="item.question"
                    class="tw-border-b tw-border-[#e4d8cc]">
                    <button
                        type="button"
                        class="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-6 tw-py-5 tw-text-left"
                        :aria-expanded="openFaq === index"
                        @click="openFaq = openFaq === index ? -1 : index">
                        <span class="tw-text-[15px] tw-text-secondary-400">{{ item.question }}</span>
                        <v-icon
                            size="18"
                            color="#6E3C4B"
                            class="tw-shrink-0 tw-transition-transform tw-duration-200"
                            :class="openFaq === index ? 'tw-rotate-45' : ''">
                            mdi-plus
                        </v-icon>
                    </button>
                    <div
                        v-show="openFaq === index"
                        class="tw-pb-5 tw-pr-8 tw-text-sm tw-leading-relaxed tw-text-gray-600">
                        {{ item.answer }}
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="tw-relative tw-overflow-hidden tw-bg-secondary-400 tw-px-6 tw-py-20 tw-text-center tw-text-[#FBF6E8] md:tw-py-24">
        <p class="tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-[0.28em] tw-text-[#FBF6E8]/80">Há sempre uma boa razão para celebrar</p>
        <div class="tw-relative tw-mx-auto tw-mt-6 tw-max-w-3xl">
            <h2 class="tw-font-serif tw-text-4xl tw-leading-[1.15] tw-text-[#F7F1E6] md:tw-text-6xl">
                O próximo bolo pode<br />
                contar a tua <span class="tw-italic tw-text-primary-600">história.</span>
            </h2>
            <img
                src="@/assets/images/cake-logo-white.png"
                alt=""
                class="tw-mx-auto tw-mt-8 tw-h-24 tw-w-24 tw-object-contain md:tw-absolute md:tw-right-0 md:tw-top-1/2 md:tw-mx-0 md:tw-mt-0 md:tw-h-28 md:tw-w-28 md:-tw-translate-y-1/2"
                style="mix-blend-mode: screen" />
        </div>
        <p class="tw-mt-8 tw-text-sm tw-text-[#FBF6E8]/85">Começamos com aquilo que torna o teu momento especial.</p>
    </section>

    <section class="tw-bg-primary-200 tw-py-16">
        <div class="tw-mx-auto tw-max-w-7xl tw-px-4">
            <div class="tw-grid tw-grid-cols-1 tw-items-center tw-gap-10 lg:tw-grid-cols-12">
                <div class="lg:tw-col-span-5">
                    <span class="tw-text-sm tw-font-medium tw-uppercase tw-tracking-widest tw-text-secondary">Visita-nos</span>
                    <h2 class="tw-font-serif tw-mb-6 tw-mt-2 tw-text-3xl tw-text-secondary md:tw-text-4xl">O Atelier em Pitões das Júnias</h2>

                    <div class="tw-space-y-6">
                        <div class="tw-flex tw-items-start tw-gap-4">
                            <div class="tw-rounded-full tw-bg-secondary tw-p-3">
                                <v-icon color="white">mdi-map-marker</v-icon>
                            </div>
                            <div>
                                <h4 class="tw-font-bold tw-text-secondary">Endereço</h4>
                                <p class="tw-text-gray-700">Rua do Outeiro, nº 24<br />5470-370 Pitões das Júnias</p>
                                <p class="tw-text-sm tw-italic tw-text-secondary tw-text-gray-600">Padaria Pitões - Família Marinho</p>
                            </div>
                        </div>

                        <div class="tw-flex tw-items-start tw-gap-4">
                            <div class="tw-rounded-full tw-bg-secondary tw-p-3">
                                <v-icon color="white">mdi-clock-outline</v-icon>
                            </div>
                            <div>
                                <h4 class="tw-font-bold tw-text-secondary">Horário</h4>
                                <p class="tw-text-gray-700">Segunda a Domingo: 07:30 – 01:00</p>
                                <p class="tw-text-xs tw-font-medium tw-text-secondary">Estamos abertos todos os dias para te receber!</p>
                            </div>
                        </div>

                        <div class="tw-flex tw-items-start tw-gap-4">
                            <div class="tw-rounded-full tw-bg-secondary tw-p-3">
                                <v-icon color="white">mdi-phone</v-icon>
                            </div>
                            <div>
                                <h4 class="tw-font-bold tw-text-secondary">Telefone</h4>
                                <p class="tw-text-gray-700">+351 276 563 103</p>
                            </div>
                        </div>
                    </div>

                    <v-btn
                        block
                        size="large"
                        variant="flat"
                        color="secondary"
                        class="tw-mt-10 tw-rounded-none tw-text-primary-100"
                        href="https://www.google.com/maps/dir/?api=1&destination=Padaria+Pitões+Família+Marinho"
                        target="_blank">
                        Obter Direções
                    </v-btn>
                </div>

                <div class="tw-h-[450px] tw-w-full tw-overflow-hidden tw-rounded-lg tw-border tw-border-secondary/10 tw-shadow-inner lg:tw-col-span-7">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2959.349633658231!2d-7.953537484551221!3d41.8426490792247!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd3b30e77e5f3529%3A0x882511da998628f9!2sPadaria%20Pit%C3%B5es%20-%20Fam%C3%ADlia%20Marinho!5e0!3m2!1spt-PT!2spt!4v1700000000000!5m2!1spt-PT!2spt"
                        width="100%"
                        height="100%"
                        style="border: 0"
                        allowfullscreen
                        loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade">
                    </iframe>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="ts" setup>
    import { onMounted, onUnmounted, ref } from 'vue';
    import { useRouter } from 'vue-router';

    const router = useRouter();

    const getImageUrl = (path: string) => {
        const cleanPath = path.replace('@/', '');
        return new URL(`/src/${cleanPath}`, import.meta.url).href;
    };

    const slides = [
        getImageUrl('assets/images/vintage_cakes/aff9a703-af3e-4fb9-b1f4-1f8a6707f195.jpeg'),
        getImageUrl('assets/images/floral_cakes/5f1650fa-0671-4865-a162-370201230df1.jpeg'),
        getImageUrl('assets/images/bento_cakes/dde7e742-c62b-4bba-a6a7-7d55edd4ed00.jpeg'),
        getImageUrl('assets/images/IMG_1096.jpeg'),
        getImageUrl('assets/images/WhatsApp Image 2026-07-27 at 21.30.07 (14).jpeg'),
    ];

    const activeSlide = ref(0);
    const openFaq = ref(-1);
    let timer: number | undefined;

    const faqs = [
        {
            question: 'Quanto custa um bolo personalizado?',
            answer: 'A base é 17 €/kg. O peso depende da massa, dos recheios e do número de pessoas. Modelagens, decorações e eventual entrega podem ter custos adicionais. O valor final é sempre confirmado pela Marina.',
        },
        {
            question: 'Com quanta antecedência devo pedir?',
            answer: 'Contacta o atelier assim que tiveres uma data em mente. A antecedência depende da agenda e da complexidade do bolo. Enviar o pedido não reserva a data; a disponibilidade é confirmada diretamente com a Marina.',
        },
        {
            question: 'Ainda não sei bem o que quero. Posso pedir ajuda?',
            answer: 'Claro. Começa por uma ocasião, uma cor, um tema ou uma das fotografias da coleção. Podes deixar os sabores por decidir. O pedido ajuda-te a reunir o que já sabes para conversar com o atelier.',
        },
        {
            question: 'Posso escolher a massa e o recheio?',
            answer: 'Sim. No pedido podes combinar massas e recheios. A combinação e a viabilidade do desenho são depois confirmadas pela Marina.',
        },
        {
            question: 'Onde levanto o bolo? Fazem entregas?',
            answer: 'O levantamento é na Padaria Pitões — Família Marinho, Rua do Outeiro, n.º 24, em Pitões das Júnias. Também podes pedir entrega ao domicílio. Zona, custo e disponibilidade precisam de confirmação.',
        },
        {
            question: 'E se houver alergias ou restrições alimentares?',
            answer: 'Indica-as no pedido e fala diretamente com o atelier antes de encomendar. Escolher uma massa ou um recheio não garante ausência de alergénios nem de contacto cruzado. Só o atelier pode confirmar se consegue responder.',
        },
    ];

    onMounted(() => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        timer = window.setInterval(() => {
            activeSlide.value = (activeSlide.value + 1) % slides.length;
        }, 4500);
    });

    onUnmounted(() => {
        if (timer) window.clearInterval(timer);
    });

    const orderThis = (product: { name: string; image: string }) => {
        sessionStorage.setItem('atelier-inspiration', JSON.stringify({ name: product.name, fotoUrl: product.image }));
        router.push({ name: 'Order', query: { inspiracao: '1' } });
    };

    const bestSellers = [
        {
            id: 1,
            image: getImageUrl('assets/images/nePhotos/rato2.JPG'),
            name: 'Ratatouille',
            description:
                'Uma homenagem às raízes francesas para o meu aniversário! A ideia é trazer o nosso amigo à vida e celebrar com ele!',
            price: '115',
        },
        {
            id: 2,
            image: getImageUrl('assets/images/nePhotos/IMG_9869.jpg'),
            name: 'Um conto de fadas',
            description: 'Trazer um pequena fada e a sua casinha cogumelo para realizar os nossos maiores desejos no dia mais especial! ',
            price: '130',
        },
        {
            id: 3,
            name: 'O Leão aniversariante',
            description: 'Um bolo para o nosso leão, que apesar de ser o rei da selva, também gosta de um presentinho no seu dia!',
            price: '20',
            image: getImageUrl('assets/images/nePhotos/IMG_9870.jpg'),
        },
    ];
</script>

<style scoped>
    .hero-slide {
        transition: opacity 1s ease-in-out;
    }

    @media (prefers-reduced-motion: reduce) {
        .hero-slide {
            transition: none;
        }
    }
</style>
